export const isMobileDevice = () => {
    return /Android|iPhone|iPad/i.test(
        navigator.userAgent
    )
}

export const isAndroidDevice = () => {
    const ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('android') > -1
}

export const isIosDevice = () => {
    const ua = navigator.userAgent.toLowerCase()
    return ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1;
}
